import lambdaClient from '../lambdaClient';
import firebase from '../firebase';
import API_KEYS from '../constants/apiKeys';
import { isProduction } from '../utils';


const sendToSlack = text => {
    lambdaClient(API_KEYS.SLACK_WEBHOOK_URL, 'POST', { text });
};

export default {
    notify: (message) => {
        sendToSlack(message);
    },
    error: (message) => {
        sendToSlack('You have a new error: ' + JSON.stringify(message));
    },
    analytics: (eventName) => {
        if (isProduction()) {
            return firebase.analytics().logEvent(eventName);
        }

        return console.log(
            'Analytics Triggered: \n' +
            eventName,
        );
    },
};
